<template>
	<div class="bg5 p4">
		<!-- Select Client -->
		<span class="xs-12 fw7 lh125 fs4">{{ $t("payor") }}</span>
		<core-select-client
			class="mb4"
			v-model="selectedPayors"
			clientType="individual"
		></core-select-client>

		<core-form-input
			componentName="j-base-input-text"
			name="name"
			:label="$t('name')"
			v-validate="'required'"
			v-model="form.name"
			:validationErrors="errors"
		/>
		<core-form-input
			componentName="j-base-input-text"
			name="comment"
			class="mt6"
			:label="$t('comment')"
			v-model="form.comment"
			:validationErrors="errors"
		/>
		<core-form-input
			componentName="j-base-input-number"
			name="amount"
			class="mt6"
			:label="$t('amount')"
			v-validate="'required'"
			v-model="form.amount"
			:validationErrors="errors"
		/>
		<core-form-input
			componentName="j-base-select"
			name="currency"
			class="mt6"
			:label="$t('currency')"
			:options="currencies"
			v-validate="'required'"
			v-model="form.currencyCode"
			:validationErrors="errors"
		/>
		<core-form-input
			componentName="j-base-select"
			name="method"
			class="mt6"
			:label="$t('payment_method')"
			:options="paymentMethods"
			v-validate="'required'"
			v-model="form.method"
			:validationErrors="errors"
		/>
		<core-form-input
			componentName="j-base-select"
			name="frequency"
			class="mt6"
			:label="$t('payment_frequency')"
			:options="paymentFrequency"
			v-validate="'required'"
			v-model="form.frequency"
			:validationErrors="errors"
		/>

		<!-- Buttons -->
		<div class="flex xs-between mt6">
			<j-button :isLoading="isLoading" @click="handleSave">{{
				$t("save")
			}}</j-button>
			<j-button @click="handleCancel" type="bordered">{{
				$t("cancel")
			}}</j-button>
		</div>
	</div>
</template>

<script>
import CoreSelectClient from "@/modules/core/components/CoreSelectClient"
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
import { currencies, paymentMethods, paymentFrequency } from "@/forms/enums.js"
import gql from "@/api/gql.js"

export default {
	components: {
		CoreFormInput,
		CoreSelectClient,
		JButton
	},

	props: {
		id: String,
		type: String,
		name: String,
		comment: String,
		amount: Number,
		method: String,
		frequency: String,
		currencyCode: String,
		payor: Object
	},

	data() {
		return {
			selectedPayors: [], // contains selected client id and name, mainly used for CoreSelectClient searching
			clientType: "individual",
			fetchedClient: {},
			isLoading: false,
			form: {
				name: "",
				comment: "",
				amount: "",
				method: "",
				frequency: "",
				currencyCode: this.$store.state.settings.preferredCurrency
			},
			currencies: currencies,
			paymentMethods: paymentMethods,
			paymentFrequency: paymentFrequency
		}
	},

	methods: {
		async handleSave() {
			// Validate
			const isValid = await this.$validator.validate()
			if (!isValid) {
				this.$store.dispatch("showError", [
					"There are some missing or incorrect fields in the form"
				])
				return
			}

			if (this.type === "" || this.type === null) return
			if (this.type === "add") this.addPayment()
			if (this.type === "update") this.updatePayment()
		},
		async addPayment() {
			const caseId = this.$route.params.id
			const input = {
				...this.form,
				payorId:
					this.selectedPayors.length > 0 ? this.selectedPayors[0].id : null
			}
			this.isLoading = true

			const res = await this.apiAddPaymentInfo({ caseId, input })

			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.$emit("added")
		},
		async apiAddPaymentInfo(variables) {
			const mutation = `
        mutation addPaymentInfo($caseId: String! $input: addPaymentInfoInput!){
          addPaymentInfoToCase(caseId: $caseId, input: $input){
                    status
              }
        }
      `
			const res = await gql({
				query: mutation,
				variables
			})
			return Promise.resolve(res)
		},

		async apiUpdatePaymentInfo(variables) {
			const mutation = `
        mutation updatePaymentInfo($caseId: String! $paymentInfoId: String! $paymentInfosToUpdate: paymentInfosToUpdate!){
          updatePaymentInfoOfCase(caseId: $caseId, paymentInfoId: $paymentInfoId, input: $paymentInfosToUpdate){
                    status
              }
        }
      `
			const res = await gql({
				query: mutation,
				variables
			})
			return Promise.resolve(res)
		},

		async updatePayment() {
			const caseId = this.$route.params.id
			const paymentInfoId = this.id
			const paymentInfosToUpdate = {
				...this.form,
				payorId: this.selectedPayors[0].id
			}
			delete paymentInfosToUpdate.payor
			this.isLoading = true

			const res = await this.apiUpdatePaymentInfo({
				caseId,
				paymentInfoId,
				paymentInfosToUpdate
			})

			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.$emit("updated")
		},

		handleCancel() {
			this.$emit("cancelled")
		},

		initialize() {
			if (this.type === "add") return

			if (this.payor) {
				this.selectedPayors = [this.payor]
				if (this.selectedPayors[0].identities)
					delete this.selectedPayors[0].identities
			}

			this.form = {
				payor: this.payor,
				name: this.name,
				comment: this.comment,
				amount: this.amount,
				currencyCode: this.currencyCode,
				method: this.method,
				frequency: this.frequency
			}
		}
	},

	mounted() {
		this.initialize()
	}
}
</script>
